/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description favoritesView constants
 */

// listables action
export const BEGIN_FETCHING_LISTABLES = '@@nzr/favoritesView/BEGIN_FETCHING_LISTABLES'
export const RECEIVE_LISTABLES = '@@nzr/favoritesView/RECEIVE_LISTABLES'
export const DONE_FETCHING_LISTABLES = '@@nzr/favoritesView/DONE_FETCHING_LISTABLES'

// view action
export const HIDE = '@@nzr/favoritesView/HIDE'
export const SHOW = '@@nzr/favoritesView/SHOW'

// misc
export const ADD_LIST_ITEM = '@@nzr/favoritesView/ADD_LIST_ITEM'
export const REMOVE_LIST_ITEM = '@@nzr/favoritesView/REMOVE_LIST_ITEM'
export const RESET = '@@nzr/favoritesView/RESET'
